export default "__VITE_ASSET__0ApEYFIg__"